module.exports = __webpack_public_path__ + "static/material-theme-461fa3edd06f20cb6c0d9a0544bb6508.png";